module.exports = __webpack_public_path__ + "static/img/20261104_1.6ad5c58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20261104_1.jpg
// module id = EEYG
// module chunks = 98